// extracted by mini-css-extract-plugin
export default {"error":"FormError_error__Cu-RF","warning":"FormError_warning__G5g+h"};